<template>
    <v-container  class="align-start mt-3">
        <v-row>
            <v-col md="4" offset-md="3" offset-sm="0">
                <v-select
                    style="width: 150px"
                    :items="seasons"
                    v-model="currentSeason"
                    label="Season"
                    :hint="selectedYear"
                >

                </v-select>
            </v-col>
        </v-row>
        <v-row>
            <v-col md="4" offset-md="3" offset-sm="0"  xs="12">
                <stats-card :gameStats="selectedStats" style="min-width: 300px"></stats-card>
            </v-col>
            <v-col md="4">    
                <calendar></calendar>            
            </v-col>
            <v-col md="4">

            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import StatsCard from '../components/StatsCard'
import Calendar from '../components/Calendar'
  export default {
    name: 'Home',
    data() {
        return {            
            currentSeason: "All",
            seasons: ["All"],            
        }
    },
    components: {
        StatsCard,
        Calendar
    },
    watch: {
        gameStats: {
            deep: true,
            handler(){
                this.seasons = ["All", ...Object.keys(this.gameStats.seasons)]
            }
        }
    },
    computed: {
        ...mapGetters(['gameStats']),
        selectedStats(){
            if(this.currentSeason == "All"){
                return this.gameStats
            } else {
                return this.gameStats.seasons[this.currentSeason]
            }
        },
        selectedYear(){
            if(this.currentSeason != "All"){
                return (2015 + +this.currentSeason).toString()
            }else {
                return ""
            }
        }
    },
    mounted(){
        this.seasons = Object.keys(this.gameStats.seasons) != 0 ? ["All", ...Object.keys(this.gameStats.seasons)]: ["All"]
    }
  }
</script>
